import type { Arrow } from '@octopus-do/octopus-project-core'
import type { AppState } from '@store/types'

export const migrationCanvasSelectors = {
  getSelectedArrowForCanvas: ({
    manager: {
      project: { arrows },
    },
    canvas,
  }: AppState): Arrow | undefined => {
    const { selectedArrowId } = canvas.arrow

    return arrows.find((arrow) => arrow.id === selectedArrowId)
  },

  getCanvasExternalLinkOffset: (state: AppState) =>
    state.canvas.externalLink.externalLinkOffset,
  getScale: (state: AppState) => state.canvas.scale,
}
